import React from 'react'
import classnames from 'classnames'

// The ONLY source of the Price Adjust sign — the box beside it stays unsigned.
// aria-pressed toggles rather than the Appearance toggle's tablist/tab pair,
// because a tablist always has one selected tab and this control has a real
// neutral state (zero) where neither sign is chosen.
const SIGN_OPTIONS = [
    {value: 1,  symbol: '+', label: 'Increase price', idKey: 'price_adjust_plus'},
    {value: -1, symbol: '−', label: 'Decrease price', idKey: 'price_adjust_minus'},
]

export const PriceAdjustSignToggle = ( { sign, onChange, buildId } ) => {
    return (
        <div
            className={'price-adjust-sign'}
            role={'group'}
            aria-label={'Price adjust direction'}
        >
            {SIGN_OPTIONS.map((option) => (
                <button
                    key={option.value}
                    // Same `Component-field-pricingId` id shape as the row's
                    // inputs so Enter-to-save works from the selector too.
                    id={buildId(option.idKey)}
                    type={'button'}
                    aria-label={option.label}
                    aria-pressed={sign === option.value}
                    className={classnames('price-adjust-sign_option', {
                        active: sign === option.value
                    })}
                    onClick={() => onChange(option.value)}
                >
                    {option.symbol}
                </button>
            ))}
        </div>
    )
}
